module.exports = __webpack_public_path__ + "img/systemmaintain.399ed1e6.png";